import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = ["src"]

import { IonInput, IonLabel, IonItem, IonTextarea } from "@ionic/vue";

import {
  ref,
  onMounted,
  PropType,
  computed,
  watch,
  onBeforeUnmount,
  ComponentPublicInstance,
} from "vue";
import { IFont, getFont } from "@/helpers/fonts";
import { TextFieldTypes, IonInputCustomEvent } from "@ionic/core";
import { getIcon } from "@/helpers/api";
import { onlyNumbers } from "@/globals/keyboards/keyPressed";
//import AssessmentContainer from "@/modules/a.worksheets/views/components/footer/AssessmentContainer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MilageInput',
  props: {
  value: { type: [String, Number], default: () => "" },
  type: {
    type: String as PropType<TextFieldTypes>,
    validator(value: string) {
      return [
        "text",
        "date",
        "number",
        "password",
        "email",
        "tel",
        "url",
        "search",
        "time",
        "week",
        "month",
        "datetime-local",
        "hidden",
      ].includes(value);
    },
    default: () => "text" as TextFieldTypes,
  },
  label: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  readonly: { type: Boolean, default: () => false },
  isWarning: { type: Boolean, default: false },
  showSendButton: { type: Boolean, default: () => false },
  maxNum: { type: Number, default: () => undefined },
  autofocus: { type: Boolean, default: false },
  accept: { type: String, default: () => "*" },
  isBigger: { type: Boolean, default: false },
  minNum: { type: Number, default: () => undefined },
  multiLine: { type: Boolean, default: false },
  isForPoints: { type: Boolean, default: false },
},
  emits: [
  "update:value",
  "click",
  "send-button-click",
  "getInputEl",
  "focusout",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const ionInputEl = ref<typeof IonInput | null>(null);
const isWarningClass = computed(() => (props.isWarning ? "is-warning" : ""));

const sendSvg = ref<string | undefined>();
const nore12Style = ref<IFont>();

onMounted(async () => {
  nore12Style.value = await getFont("nore12");
  sendSvg.value = await getIcon("1610A", "send");
});

function ionChangeEvent(ev: CustomEvent) {
  const target = ev.target as HTMLInputElement | HTMLTextAreaElement | null;
  //let newValue = target?.value ?? "";

  //if (props.isForPoints) {
  //  newValue = newValue.replace(/[^0-9]/g, "");
  //}

  emit("update:value", target?.value ?? "", inputComponentRef.value?.$el);
}

watch(ionInputEl, () => {
  if (ionInputEl.value) emit("getInputEl", ionInputEl.value!.$el);
});
const valueCopy = ref(props.value as any);

watch(
  () => props.value,
  (nv) => {
    valueCopy.value = nv as any;
  },
  { immediate: true }
);

function sendButtonClick() {
  emit("send-button-click");
  emit("focusout");
}

const componentRef = ref<ComponentPublicInstance | null>(null);
const inputComponentRef = ref<ComponentPublicInstance | null>(null);

onMounted(() => {
  setTimeout(() => {
    document.addEventListener("click", handleClickOutside);
  }, 100);
});
onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

function handleClickOutside(e: MouseEvent) {
  if (
    componentRef.value &&
    !componentRef.value.$el.contains(e.target as Node)
  ) {
    emit("focusout", e);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    class: _normalizeClass(["input-box", [isWarningClass.value]]),
    lines: "none",
    onClick: _cache[1] || (_cache[1] = (e) => emit('click', e)),
    ref_key: "componentRef",
    ref: componentRef
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), {
        style: _normalizeStyle(nore12Style.value),
        class: _normalizeClass([{ 'is-bigger': __props.isBigger }, "absolute-label"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ]),
        _: 1
      }, 8, ["style", "class"]),
      (props.multiLine)
        ? (_openBlock(), _createBlock(_unref(IonTextarea), {
            key: 0,
            style: _normalizeStyle(nore12Style.value),
            placeholder: __props.placeholder,
            value: valueCopy.value,
            autofocus: __props.autofocus,
            readonly: __props.readonly,
            onIonInput: ionChangeEvent,
            ref_key: "inputComponentRef",
            ref: inputComponentRef
          }, null, 8, ["style", "placeholder", "value", "autofocus", "readonly"]))
        : (__props.isForPoints)
          ? (_openBlock(), _createBlock(_unref(IonInput), {
              key: 1,
              style: _normalizeStyle(nore12Style.value),
              type: __props.type,
              placeholder: __props.placeholder,
              value: valueCopy.value,
              min: __props.minNum,
              autofocus: __props.autofocus,
              onKeydown: _unref(onlyNumbers),
              onIonInput: ionChangeEvent,
              readonly: __props.readonly,
              accept: __props.accept,
              onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              ref_key: "inputComponentRef",
              ref: inputComponentRef
            }, null, 8, ["style", "type", "placeholder", "value", "min", "autofocus", "onKeydown", "readonly", "accept"]))
          : (_openBlock(), _createBlock(_unref(IonInput), {
              key: 2,
              style: _normalizeStyle(nore12Style.value),
              type: "text",
              placeholder: __props.placeholder,
              value: valueCopy.value,
              min: __props.minNum,
              autofocus: __props.autofocus,
              onIonInput: ionChangeEvent,
              readonly: __props.readonly,
              accept: __props.accept,
              ref_key: "inputComponentRef",
              ref: inputComponentRef
            }, null, 8, ["style", "placeholder", "value", "min", "autofocus", "readonly", "accept"])),
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_Transition, { name: "send" }, {
        default: _withCtx(() => [
          (__props.showSendButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "send-button",
                slot: "end",
                onClick: sendButtonClick
              }, [
                _createElementVNode("img", { src: sendSvg.value }, null, 8, _hoisted_1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})